export default function getAltImage(alt) {
  if (!alt) {
    return "";
  }
  return alt.replaceAll(`"`, `'`);
}